import { LENDER_ENDPOINTS } from "../constants/apiEndpoints";
import { getWrapperWeb, postWrapperWeb } from "../utils/Wrapper";

// export const getAllProposals = async (status = null) => {
//   try {
//     const url = status
//       ? `${WEB_BASE_URL}/proposal/get-by-id-and-status?status=${status}`
//       : `${WEB_BASE_URL}/proposal/get-by-id-and-status`;

//     return await getWrapper(url);
//   } catch (error) {
//     toast.error(error.message);
//     throw error;
//   }
// };

export const getAllProposals = async (status) => {
  const url = status
    ? `/proposal/get-by-id-and-status?status=${status}`
    : `/proposal/get-by-id-and-status`;
  return getWrapperWeb(url);
};

// export const getProposalByLenderAndId = async (lenderId, proposalId) => {
//   try {
//     const url = `${WEB_BASE_URL}/proposal/get-by-lender-and-proposal?lenderId=${lenderId}&proposalId=${proposalId}`;
//     return await getWrapper(url);
//   } catch (error) {
//     toast.error(error.message);
//     throw error;
//   }
// };

export const getProposalByLenderAndId = async (lenderId, proposalId) => {
  const url = `/proposal/get-by-lender-and-proposal?lenderId=${lenderId}&proposalId=${proposalId}`;
  return getWrapperWeb(url);
};

export const createProposal = async (proposalData) => {
  const formData = new FormData();
  
  if (proposalData.files?.cma) {
    const cmaFile = proposalData.files.cma;
    if (!cmaFile.generatedFromButton) {
      if (cmaFile.s3Url) {
        formData.append('cmaLink', cmaFile.s3Url);
      } else {
        formData.append('cma', cmaFile);
      }
    }
  }
  if (proposalData.files?.onePager) {
    const onePagerFile = proposalData.files.onePager;
    if (!onePagerFile.generatedFromButton) {
      if (onePagerFile.s3Url) {
        formData.append('onePagerLink', onePagerFile.s3Url);
      } else {
        formData.append('onePager', onePagerFile);
      }
    }
  }
  
  formData.append('applicationId', proposalData.applicationId || '');
  formData.append('applicationNumber', proposalData.applicationNumber || '');
  formData.append('userId', proposalData.user_id || proposalData.userId || '');
  formData.append('borrowerId', proposalData.borrowerId || '');
  formData.append('proposalBrief', proposalData.proposalBrief || '');
  
  if (proposalData.lenderId) {
    const lenderIds = Array.isArray(proposalData.lenderId)
      ? proposalData.lenderId
      : [proposalData.lenderId];
    lenderIds
      .filter(Boolean)
      .forEach((id) => formData.append('lenderId', id));
  }
  
  const url = `/proposal/create`;
  return postWrapperWeb(url, formData);
};

export const updateProposalDetails = async (proposalData) => {
  const formData = new FormData();

  ['cma', 'onePager'].forEach((key) => {
    const file = proposalData?.files?.[key];
    if (file && !file.generatedFromButton) {
      if (file.s3Url) {
        formData.append(`${key}Link`, file.s3Url);
      } else {
        formData.append(key, file);
      }
    }
  });

  const fields = {
    id: proposalData.id,
    applicationId: proposalData.applicationId,
    applicationNumber: proposalData.applicationNumber,
    userId: proposalData.userId,
    borrowerId: proposalData.borrowerId,
    proposalBrief: proposalData.proposalBrief,
  };

  Object.entries(fields).forEach(([key, value]) => {
    const hasValue = value !== undefined && value !== null && (typeof value === 'number' || (typeof value === 'string' && value !== ''));
    if (hasValue) formData.append(key, value);
  });

  const lenderIds = Array.isArray(proposalData.lenderId)
    ? proposalData.lenderId
    : (proposalData.lenderId ? [proposalData.lenderId] : []);
  lenderIds.filter(Boolean).forEach((id) => formData.append('lenderId', id));

  const url = `/proposal/update-proposal-details`;
  return postWrapperWeb(url, formData);
};

// export const createProposal = async (proposalData) => {
//   try {
//   const data = {
//     applicationId: parseInt(proposalData.applicationId, 10),
//     applicationNumber: proposalData.applicationNumber,
//     user_id: parseInt(proposalData.user_id, 10),
//     borrowerId: parseInt(proposalData.borrowerId, 10),
//     lenderId: Array.isArray(proposalData.lenderId) ? proposalData.lenderId : [proposalData.lenderId]
//   };
//     const url = `${WEB_BASE_URL}/proposal/create`;
//     return await postWrapper(url, data);
//   } catch (error) {
//     toast.error(error.message);
//     throw error;
//   }
// };

// export const getLendersList = async (data) => {
//   try {
//     const url = `${WEB_BASE_URL}${LENDER_ENDPOINTS.GET_ALL}`;
//     return await getWrapper(url, data);
//   } catch (error) {
//     toast.error(error.message);
//     throw error;
//   }
// };

export const getLendersList = async (data) => {
  const url = `${LENDER_ENDPOINTS.GET_ALL}`;
  return getWrapperWeb(url, data);
};

export const getProposalsByLenderId = async (lenderId, status = "all") => {
  const url = `/proposal/get-by-id-and-status?lenderId=${lenderId}${
    status !== "all" ? `&status=${status}` : ""
  }`;
  return getWrapperWeb(url);
};

// export const getProposalsByLenderId = async (lenderId, status = 'all') => {
//   try {
//     const url = `${WEB_BASE_URL}/proposal/get-by-id-and-status?lenderId=${lenderId}${status !== "all" ? `&status=${status}` : ''}`;
//     return await getWrapper(url);
//   } catch (error) {
//     toast.error(error.message);
//     throw error;
//   }
// };

// export const getProposalById = async (proposalId) => {
//   try {
//     const url = `${WEB_BASE_URL}/proposals/${proposalId}`;
//     return await getWrapper(url);
//   } catch (error) {
//     toast.error(error.message);
//     throw error;
//   }
// };

export const getProposalById = async (proposalId) => {
  const url = `/proposals/${proposalId}`;
  return getWrapperWeb(url);
};

// export const getProposalById = async (proposalId) => {
//   try {
//     const token = getWebToken(); // Use web token for this endpoint
//     if (!token) {
//       throw new Error('Web token not found');
//     }

//     const response = await axios.get(`${WEB_BASE_URL}/proposals/${proposalId}`, {
//       headers: {
//         'accept': '*/*',
//         'Authorization': `Bearer ${token}`
//       }
//     });

//     if (response.data.responseCode === 200) {
//       return response.data;
//     } else {
//       throw new Error(response.data.message || 'Failed to fetch proposal details');
//     }
//   } catch (error) {
//     console.error('Error in getProposalById:', error);
//     throw error.response?.data?.message || error.message || 'Failed to fetch proposal details';
//   }
// };
